var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 38,
    viewBox: "0 0 58 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    width: 58,
    height: 40.3197,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_797_1816",
    transform: "scale(0.00371747 0.00534759)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_797_1816",
    width: 269,
    height: 187,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ0AAAC7CAMAAABIKDvmAAAAilBMVEX///8nM3XhAA/gAAAdK3Fwdp3pZ2wlMXTkISo9R4LhAAvhAAVRWo03Qn97gaXrcXbjFSCmqsENIG0IHWyWmrUYJ3BiaZbW1+LkJi/mQEfxoqT62doAGWryq63N0N0qN3j4y82MkbAAEmjuiYztf4O+wdL2v8GeorzvlpnpZGjiChboV1vwmZvxpKaVedYrAAACIklEQVR4nO3V2VLiQACG0TYdFoNAQFFUhs3dGd//9QScgGV52bnoqvM9wN9VpzqdEI7dTEYX54kajkKbjet+mua347v7Xw6YlItZ2UtV2WlVoxurRA1ijPWfH/PL1bR3lrDWNYqEDWK9/r6+2Sa1yExj7/FwGu9cprXITqMoYrfZ3iTHyE+jiI9f00/b5BgZahTx+TBdJn4zMtWo4n75ZZoeI0eNIt7tltP+WjPW2F+OZfonNFONIq7D1YxGo/Eartv4UDLVeAvDNjDy1KjmYUXj2HtoBSNTjYIGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRo0aNCgQYMGDRoJNFY0jr2HIY2mqh+uezT+F/+GqxmNRuM1LBc0Go11CLM2PpUcNaq4W36Z0jgU/+2nyxYuR4Yah6sRwtOWxq74/LW9uaRRxMdmvJOcIzuN2D2tb7aJ347MNAbx4fv8cjVN6pGVxiBW6x8HTMrFrOylqnWNKlGDGGP98csRN5PRxXmihqNWNcZ1P03z2/HH/Wn3E7Z54m4PTqc2AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrench);
export default __webpack_public_path__ + "static/media/french.717f6873e9bd97f57cc37edd036bf636.svg";
export { ForwardRef as ReactComponent };